import styled from 'styled-components';

import { Modal } from '@pkg/components/Modal';
import { YatSprite } from '@pkg/components/YatSprite';

export const ModalLayout = styled(Modal.Layout)`
    padding: 70px 0 40px 0;
    gap: 16px;
    min-height: calc(100vh - 102px);
    justify-content: center;
    display: flex;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        min-height: unset;
    }
`;

export const StyledStar = styled(YatSprite)`
    width: 60px;
    height: 60px;
`;

export const AddIconCircle = styled.div`
    width: 42px;
    height: 42px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    svg {
        width: 18px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 60px;
        height: 60px;
    }
`;

export const Footer = styled.div`
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    height: 102px;
    border-radius: 0 0 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 40px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 140px;
    }
`;

export const CreateWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    &:hover > div:first-of-type {
        border: 2px solid rgba(255, 255, 255, 0.8);
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 20px;
    }
`;

export const Input = styled.input`
    && {
        font-weight: 700;
        font-size: 18px;
        line-height: 105%;
        color: #ffffff;
        background: transparent;
        border: 0;
        outline: none;
        border-bottom: 1px solid #ffffff;
        border-radius: 0;
        width: 272px;
        height: 24px;
        padding: 0 0 7px 0;
        margin-bottom: 3px;
        margin-top: 10px;
    }
`;

export const CreateText = styled.div`
    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: -0.03em;
    color: #ffffff;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
        line-height: 105%;
    }
`;

export const NFTAssetWrapper = styled.div`
    width: 80px;
    height: 80px;
    background-color: ${(props) => props.theme?.colors.black};
    filter: drop-shadow(0 0 33.355px rgba(0, 0, 0, 0.25));
    border-radius: 8px;
`;

export const SectionWrapper = styled.div`
    display: grid;
    align-content: baseline;
    justify-items: center;
    gap: 10px;
    padding: 0 25px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0;
    }
`;

export const SubheadingLabel = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.03em;
    margin-top: 14px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
        line-height: 110%;
    }
`;
